var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var MedProfileModel = require('../../models/med-profile-model');
var MedicationForm = require('./medication-form.js');
var CommonUtils = require('../../utils/common-utils.js');
var DeleteConfirmationModal = require('../common/delete-confirmation-modal');

var DocumentsCollection = require('../../collections/documents-collection');

var Radio = require('backbone.radio');
var services = Radio.channel('services');
var notificationsChannel = Radio.channel('notifications');
var actionsChannel = Radio.channel('actions');
var utils = new CommonUtils();

var MedicationsRowView = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/medicals/medication.html'),

    ui: {
        edit: '.edit',
        remove: '.remove',
        addEvent: '.add-event',
        showDiseases: '.diseases-show',
        showDocuments: '.documents-show'
    },

    events: {
        'click @ui.edit': 'onEdit',
        'click @ui.remove': 'onRemove',
        'click @ui.addEvent': 'onAddNewEvent',
        'click @ui.showDiseases': 'onDiseasesShow',
        'click @ui.showDocuments': 'onDocumentsShow'
    },

    templateContext: function () {
        var that = this;
        var startDate = that.model.get('startDate');
        var stopDate = that.model.get('stopDate');
        var getFormName = that.getOption('getFormName');
        return {
            startDate: startDate != undefined && startDate != '' && !isNaN(startDate) ? utils.longToDateTimeFormatted(startDate, 'MM/DD/YYYY') : '',
            stopDate: stopDate != undefined && stopDate != '' && !isNaN(stopDate) ? utils.longToDateTimeFormatted(stopDate, 'MM/DD/YYYY') : '',
            groupSize: that.rowPositionInGroup != 0 ? 0 : that.rowGroupSize,
            isHidden: that.rowPositionInGroup != 0 ? true : false,
            formName: (that.model.get('formObj') || {}).title || "",
            dose: (that.model.get('doseObj') || {}).title || "",
            isTerminal: that.rowGroupSize - that.rowPositionInGroup == 1,
            eventTypeName: utils.getMedicationEventType(that.model.get('eventType')),
            canEdit: this.getOption('canEdit')
        }
    },

    initialize: function (options) {
        var that = this;
        window.setTimeout(function () {
            var id = that.model.get('medicationId');
            var whereFrom = (that.model.get('systemType') || '').toLowerCase();
            var servicesAddresses = options.servicesAddresses;

            var refreshRowCallback = function (name) {
                that.model.set('name', name);
                that.render();
            };

            /*if (whereFrom == 'snomed' && typeof servicesAddresses["snomedMedicationServiceAddress"] != "undefined") {
             that.refreshMedicationFromSnomed(id, servicesAddresses["snomedMedicationServiceAddress"], refreshRowCallback);
             } else*/
            if (whereFrom == 'custom' && typeof servicesAddresses["customMedicationServiceAddress"] != "undefined") {
                that.refreshMedicationFromCustom(id, servicesAddresses["customMedicationServiceAddress"], refreshRowCallback);
            } else if (whereFrom == 'rxnorm' && typeof servicesAddresses["rxnormMedicationServiceAddress"] != "undefined") {
                that.refreshMedicationFromRxNorm(id, servicesAddresses["rxnormMedicationServiceAddress"], refreshRowCallback);
            }
        }, 500);

        var modelGroupStats = this.getOption('modelGroupStats');

        var groupUuid = '';
        for (var indx in modelGroupStats) {
            if (modelGroupStats[indx].medicationUuid == that.model.get('medicationUuid')) {
                groupUuid = modelGroupStats[indx].groupUuid;
                break;
            }
        }

        that.rowPositionInGroup = 0;
        var currentGroupRows = modelGroupStats.filter(function (elem) {
            return elem.groupUuid == groupUuid;
        });
        for (var indx in currentGroupRows) {
            if (currentGroupRows[indx].medicationUuid == that.model.get('medicationUuid')) {
                that.rowPositionInGroup = indx;
                break;
            }
        }

        that.rowGroupSize = currentGroupRows.length;

        if (that.rowGroupSize - that.rowPositionInGroup == 1){
            this.$el.toggleClass('border-bottom', true);
        }
    },

    onRender: function () {
        var that = this;
        window.setTimeout(function() {
            that.ui.edit.parent().parent().hover(function() {
                var el = $(this);
                el.addClass("hover");
                if (el.has('td[rowspan]').length == 0)
                    el.prevAll('tr:has(td[rowspan]):first').find('td[rowspan]').addClass("hover");
            }, function() {
                var el = $(this);
                el.removeClass("hover");
                el.prevAll('tr:has(td[rowspan]):first').find('td[rowspan]').removeClass("hover");
            });
        }, 1000);
    },

    refreshMedicationFromSnomed: function (id, serviceAddress, callback) {
        $.when(
            $.ajax({
                type: "GET",
                url: serviceAddress + '/concepts/' + id
            })
        ).done(function (resp) {
            callback(resp.defaultTerm);
        }).fail(function (jqXHR, textStatus) {
        });
    },

    refreshMedicationFromCustom: function (id, serviceAddress, callback) {
        $.when(
            $.ajax({
                type: "GET",
                url: serviceAddress + '/api/medications/' + id
            })
        ).done(function (resp) {
            callback(resp.name);
        }).fail(function (jqXHR, textStatus) {
        });
    },

    refreshMedicationFromRxNorm: function (id, serviceAddress, callback) {
        if (!id) return;
        $.when(
            $.ajax({
                type: "GET",
                headers: {
                    Accept: 'application/json'
                },
                url: serviceAddress + '/REST/rxcui/' + id
            })
        ).done(function (resp) {
            if (resp.idGroup.name) {
                callback(resp.idGroup.name);
            }
        }).fail(function (jqXHR, textStatus) {
        });
    },

    onEdit: function () {
        this.triggerMethod('edit:medication', {model: this.model});
    },

    onRemove: function () {
        this.triggerMethod('remove:medication', {model: this.model});
    },

    onAddNewEvent: function() {
        this.triggerMethod('new:event', {model: this.model});
    },

    onDiseasesShow: function() {
        this.triggerMethod('show:diseases', this.model.get('diseasesUuids'));
    },

    onDocumentsShow: function() {
        this.triggerMethod('show:documents', this.model.get('documentsIds'));
    }
});


var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(10), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});

var MedicationsTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: MedicationsRowView,
    emptyView: EmptyView,

    collectionEvents: {},

    childViewEvents: {
        'remove:medication': 'removeMedication',
        'edit:medication': 'editMedication',
        'new:event': 'newEvent',
        'show:diseases': 'onDiseasesShow',
        'show:documents': 'onDocumentsShow'
    },

    initialize: function (options) {
        this.collection = options.collection;
        this.servicesAddresses = options.servicesAddresses;
        this.getFormName = options.getFormName;
    },

    childViewOptions: function () {
        return {
            canEdit: this.getOption('canEdit'),
            servicesAddresses: this.servicesAddresses,
            getFormName: this.getFormName,
            modelGroupStats: this.collection.map(function (model) {
                return {
                    medicationUuid: model.get('medicationUuid'),
                    groupUuid: model.get('groupUuid')
                }
            })
        };
    },

    removeMedication: function (data) {
        this.triggerMethod('remove:medication', data);
    },

    editMedication: function (data) {
        this.triggerMethod('edit:medication', data);
    },

    newEvent: function(data) {
        this.triggerMethod('new:event', data);
    },

    onDiseasesShow: function(data) {
        this.triggerMethod('show:diseases', data);
    },

    onDocumentsShow: function(data) {
        this.triggerMethod('show:documents', data);
    }
});

var MedicalRecords = Marionette.View.extend({
    template: require('../../templates/medicals/medical-profile.html'),

    regions: {
        body: {
            el: 'tbody',
            replaceElement: true
        },
        medicationForm: '#medication-form',
        deleteConfirmationModal: '#delete-confirmation-modal'
    },

    ui: {
        errorText: '#error',
        content: '#content',
        buttonsContainer: '#buttons',
        createBtn: '#create-med-record',
        addMedication: '#add',
        medicationsTable: '#medications-table',
        diseasesShowModal: '#diseases-show-modal',
        diseasesTable: '#diseases-table',
        documentsShowModal: '#documents-show-modal',
        documentsTable: '#documents-table'
    },

    events: {
        'click @ui.createBtn': 'createMedRecord',
        'click @ui.addMedication': 'addNewMedication'
    },

    childViewEvents: {
        'new:medication': 'saveNewMedication',
        'update:medication': 'updateMedication',
        'remove:medication': 'removeMedication',
        'delete:confirmed': 'deleteConfirmed',
        'edit:medication': 'editMedication',
        'new:event': 'newEvent',
        'show:diseases': 'onDiseasesShow',
        'show:documents': 'onDocumentsShow'
    },

    callback: undefined,
    deletedMedicationModel: undefined,

    templateContext: function () {
        var that = this;
        return {
            canEdit: that.canEdit,
            name: that.name
        }
    },


    initialize: function (options) {
        var that = this;
        _.bindAll(this, 'createMedRecord', 'disableElements', 'renderTable', 'addNewMedication', 'saveNewMedication',
            'deleteConfirmed', 'removeMedication', 'deepCloneObjectMedications', 'editMedication', 'updateMedication',
            'modelSave', 'newEvent', 'onDiseasesShow', 'getFormName', 'onDocumentsShow');
        if (options) {
            this.personId = options.personId;
            this.name = options.name;
            this.canEdit = options.canEdit;
        }
        this.servicesAddresses = services.request('get:services:address');
        this.defaultMedicationForms = services.request('get:default:medication:forms');

        this.documentsCollection = new DocumentsCollection([], {params: [
            {key: 'sortby', value: 'createdTime'},
            {key: 'sortdir', value: 'DESC'},
            {key: 'DOCUMENT_PATIENT', value: this.personId}
        ]});
        this.documentsCollection.fetch({
            success: function() {
                that.documents = that.documentsCollection.toJSON().map(function(document) {
                    return {
                        id: document.id,
                        name: document.name
                    }
                });
            },
            error: function(collection, response, options) {
                if (response.status == 401) {
                    actionsChannel.request("redirect:to:login");
                }
            }
        });
    },

    onRender: function () {
        var that = this;
        that.disableElements();

        $.ajax({
            type: "GET",
            url: '/api/medprofile/person/' + that.personId,
            statusCode: {
                200: function (response) {
                    that.model = new MedProfileModel(response);
                    that.triggerMethod('show:subtabs', that.model);
                    that.renderTable(response);
                    that.ui.content.show();
                },
                401: function() {
                    actionsChannel.request("redirect:to:login");
                },
                403: function (response) {
                    that.ui.errorText.show();
                },
                404: function (response) {
                    that.ui.buttonsContainer.show();
                }
            }
        });
    },

    disableElements: function () {
        this.ui.errorText.hide();
        this.ui.content.hide();
        this.ui.buttonsContainer.hide();
    },

    createMedRecord: function () {
        var that = this;
        var medProfileModel = new MedProfileModel();
        medProfileModel.get('object').personId = that.personId;
        medProfileModel.save(medProfileModel.toJSON(), {
            success: function () {
                that.triggerMethod('med:record:created');
            },
            error: function (model, xhr, options) {
                notificationsChannel.request('show:notification', xhr.responseText);
            }
        });
    },

    renderTable: function (response) {
        var that = this;
        response.object.medications.forEach(function (medication) {
            medication.id = utils.randomString(18);
        });
        that.medicationsCollection = new Backbone.Collection(response.object.medications);
        that.medicationsCollection.comparator = function (model) {
            return model.get('groupUuid');
        }
        that.medicationsCollection.sort();
        that.showChildView('body', new MedicationsTableBody({
            collection: that.medicationsCollection,
            servicesAddresses: that.servicesAddresses,
            getFormName: that.getFormName,
            canEdit: that.canEdit
        }));
    },

    addNewMedication: function () {
        var that = this;
        that.showChildView('medicationForm', new MedicationForm({
            mode: 'add',
            medication: {},
            diseases: that.model.get('object').diseases.map(that.formatDisease),
            servicesAddresses: that.servicesAddresses,
            isNewGroup: true,
            defaultMedicationForms: that.defaultMedicationForms,
            documents: that.documents
        }));
    },

    editMedication: function (data) {
        var that = this;
        that.showChildView('medicationForm', new MedicationForm({
            mode: 'edit',
            medication: data.model.toJSON(),
            diseases: that.model.get('object').diseases.map(that.formatDisease),
            servicesAddresses: that.servicesAddresses,
            defaultMedicationForms: that.defaultMedicationForms,
            documents: that.documents
        }));
    },

    saveNewMedication: function (medication) {
        var that = this;
        that.model.get('object').medications = that.model.get('object').medications.map(function (medication) {
            medication = _.omit(medication, 'id');
            return medication;
        });
        that.model.get('object').medications.push(medication);
        that.modelSave();
    },

    updateMedication: function (updatedMedication) {
        var that = this;
        that.model.get('object').medications.forEach(function (medication) {
            if (medication.id == updatedMedication.id) {
                medication.name = updatedMedication.name;
                medication.form = updatedMedication.form;
                medication.eventType = updatedMedication.eventType;
                medication.doseObj = updatedMedication.doseObj;
                medication.quantity = updatedMedication.quantity;
                medication.frequency = updatedMedication.frequency;
                medication.regularFrequency = updatedMedication.regularFrequency;
                medication.startDate = updatedMedication.startDate;
                medication.stopDate = updatedMedication.stopDate;
                medication.comment = updatedMedication.comment;
                medication.diseasesUuids = (updatedMedication.diseasesUuids || []).filter(function(diseaseUuid) {
                        return diseaseUuid != "";
                    });
                medication.documentsIds = (updatedMedication.documentsIds || []).filter(function(id) {
                    return id != "";
                });
            }
        });
        that.model.get('object').medications = that.model.get('object').medications.map(function (medication) {
            medication = _.omit(medication, 'id');
            return medication;
        });
        that.modelSave();
    },

    deleteConfirmed: function (value) {
        if (value == true) {
            var that = this;
            that.model.get('object').medications = that.model.get('object').medications.filter(function (medication) {
                return medication.id != that.deletedMedicationModel.get('id');
            }).map(function (medication) {
                medication = _.omit(medication, 'id');
                return medication;
            });
            that.modelSave();
        }
    },

    modelSave: function () {
        var that = this;
        that.model.save(that.model.toJSON(), {
            success: function (model) {
                model.get('object').medications.forEach(function (medication) {
                    medication.id = utils.randomString(18);
                });
                that.renderTable(model.toJSON());
            },
            error: function (model, xhr, options) {
                notificationsChannel.request('show:notification', xhr.responseText);
            }
        });
    },

    removeMedication: function (data) {
        this.deletedMedicationModel = data.model;
        this.deleteConfirmationModal =
            new DeleteConfirmationModal({
                message: 'Enter: "confirm" if you agree to remove the medication.',
                confirmationAnswer: 'confirm'
            });
        this.showChildView('deleteConfirmationModal', this.deleteConfirmationModal);
        this.deleteConfirmationModal.show();
    },

    deepCloneObjectMedications: function (object) {
        var clonedObject = _.clone(object);
        clonedObject.object = _.clone(object.object);
        clonedObject.object.medications = _.clone(object.object.medication);
        return clonedObject;
    },

    newEvent: function(data) {
        var that = this;
        var staticData = data.model.toJSON();
        that.showChildView('medicationForm', new MedicationForm({
            mode: 'add',
            medication: {
                name: staticData.name,
                medicationId: staticData.medicationId,
                form: staticData.form,
                groupUuid: staticData.groupUuid,
                systemType: staticData.systemType,
                diseasesUuids: staticData.diseasesUuids
            },
            diseases: that.model.get('object').diseases.map(that.formatDisease),
            servicesAddresses: that.servicesAddresses,
            defaultMedicationForms: that.defaultMedicationForms,
            documents: that.documents
        }));
    },

    formatDisease: function(disease) {
        return {
            uuid: disease.uuid,
            name: disease.name
                + (disease.startDate != undefined && disease.startDate != '' && !isNaN(disease.startDate) 
                    ? ', ' + utils.longToDateTimeFormatted(disease.startDate, 'MM/DD/YYYY') : ', ')
                + (disease.stopDate != undefined && disease.stopDate != '' && !isNaN(disease.stopDate)
                    ? ', ' + utils.longToDateTimeFormatted(disease.stopDate, 'MM/DD/YYYY') : '')
        }
    },

    onDiseasesShow: function(data) {
        var that = this;
        var diseases = that.model.get('object').diseases.filter(function(disease) {
            return _.contains(data, disease.uuid);
        }).map(function(disease) {
            return {
                uuid: disease.uuid,
                name: disease.name,
                startDate: (disease.startDate != undefined && disease.startDate != '' && !isNaN(disease.startDate)
                    ? utils.longToDateTimeFormatted(disease.startDate, 'MM/DD/YYYY') : '-'),
                stopDate: (disease.stopDate != undefined && disease.stopDate != '' && !isNaN(disease.stopDate)
                    ? utils.longToDateTimeFormatted(disease.stopDate, 'MM/DD/YYYY') : '-')
            }
        });

        $('#diseases-table tr:not(:first)').remove();
        diseases.forEach(function (disease) {
            var newRowContent = "<tr id='" + disease.uuid + "'><td>"
                + disease.name + "</td><td>" + disease.startDate + "</td><td>" + disease.stopDate + "</td></tr>";
            $('#diseases-table tbody').append(newRowContent);
        });
        this.ui.diseasesShowModal.modal('show');
    },

    getFormName: function(form) {
        var formObject = _.findWhere(this.defaultMedicationForms, {id: form});
        if (formObject == undefined)
            return null;
        else
            return formObject.name;
    },

    onDocumentsShow: function(data) {
        var that = this;
        var documents = that.documents.filter(function(document) {
            return _.contains(data, document.id);
        });

        $('#documents-table tr:not(:first)').remove();

        documents.forEach(function (document) {
            var viewContent = '<a href="/api/document/view/' + document.id + '" target="_blank"><span class="clickable glyphicon glyphicon-eye-open"/></a>';
            var newRowContent = '<tr id="' + document.id
                + '"><td><a href="/#document/' + document.id + '" target="_blank"><b>' + document.name + '</b></a></td><td>'
                + viewContent + '</td></tr>';

            $('#documents-table tbody').append(newRowContent);
        });

        this.ui.documentsShowModal.modal('show');
    }

});

module.exports = MedicalRecords;


//////////////////
// WEBPACK FOOTER
// ./app/views/medicals/medical-profile.js
// module id = 347
// module chunks = 0